import fisrtCardImg from "../Assets/Images/Untitled.png";
import fourthCardImg from "../Assets/Images/Artifical_Intelligence.png";
import fifthCardImg from "../Assets/Images/Web-Develop.png";
import sixthCardImg from "../Assets/Images/Mobile_App.png";
import { Link } from "react-router-dom";

interface ServiceCard {
  title: string;
  description: string;
  link: string;
  image?: string;
  imageClass?: string;
}

const services: ServiceCard[] = [
  {
    title: "Metaverse",
    description:
      "Metaverse is a multidimensional digital space that lies beyond the world we live in. It's a collection of all possible versions of a place or object, along with our perception of ownership and rights over them.",
    link: "/metaverse",
    image: fisrtCardImg,
    imageClass: "h-28",
  },
  {
    title: "Artificial Intelligence",
    description:
      "Artificial intelligence is the future. Take your business to the next level as we develop AI applications for various industries from healthcare & forecasting.",
    link: "/artificialIntellegence",
    image: fourthCardImg,
    imageClass: "h-28",
  },
  {
    title: "Web Development",
    description:
      "We provide exceptional web development services to help businesses worldwide establish a powerful online presence.",
    link: "/webdev",
    image: fifthCardImg,
    imageClass: "h-32",
  },
  {
    title: "Mobile App Development",
    description:
      "We offer high-end mobile app development services ranging from custom iOS, Android apps, React Native app and Flutter app development.",
    link: "/appdev",
    image: sixthCardImg,
    imageClass: "h-28",
  },
  {
    title: "Logistics & Transport",
    description:
      "We deliver smart logistics and transport solutions, from fleet management and route optimization to real-time shipment tracking, helping your business move goods faster and more efficiently.",
    link: "/logistics",
  },
];

const TruckIcon = () => (
  <svg
    className="h-28 text-neonCyan"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="1.2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
    />
  </svg>
);

const ServicesCards = () => {
  return (
    <div className="relative bg-night overflow-hidden">
      <div className="glow-orb w-[350px] h-[350px] bg-neonPurple/20 top-20 -right-24"></div>
      <div className="max-w-[1140px] mx-auto lg:py-28 md:py-16 sm:py-12 py-10 p-4 relative">
        <div>
          <h1 data-aos="fade-up" className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
            Our <span className="text-gradient">Services</span>
          </h1>
          <div className="web3-underline w-[80px] mt-3"></div>
          <p className="py-6 text-lg text-gray-400 max-w-3xl">
            In addition to Blockchain technology development, we provide a wide
            range of services to meet your business needs effectively. Our
            expertise extends to custom Web3 services, Artificial Intelligence,
            Staff Augmentation, UI/UX Design, Digital Marketing, and Logistics
            & Transport. By leveraging these services, we can help your
            business generate leads and drive sales.
          </p>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
          {services.map((service) => (
            <div key={service.title} className="glass-card p-8 flex flex-col">
              <div className="flex justify-center pb-6">
                {service.image ? (
                  <img
                    className={service.imageClass}
                    src={service.image}
                    alt={service.title}
                  />
                ) : (
                  <TruckIcon />
                )}
              </div>
              <h5 className="mb-3 text-2xl font-bold tracking-tight text-white text-center">
                {service.title}
              </h5>
              <p className="mb-6 font-normal text-gray-400 text-center flex-grow">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="flex items-center justify-center gap-2 text-customRed font-semibold hover:gap-3 transition-all"
              >
                Read more
                <svg
                  className="rtl:rotate-180 w-3.5 h-3.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesCards;
